import { render, staticRenderFns } from "./EditFavourite.vue?vue&type=template&id=28e922b8&scoped=true"
import script from "./EditFavourite.vue?vue&type=script&lang=js"
export * from "./EditFavourite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e922b8",
  null
  
)

export default component.exports